import { api } from "../../services/api"
import { listAllRawDumpApi, UpdateRawDumpApi, listAllApprovedApi, woGetPreviousMonthsApi }  from "../../services/apiVariables"
import { GetMonthYear, productUnit } from '@src/function.js'

// ----------------------Raw Dump Approval Screen-----------------------------
export function RawDumpWorkOrderDetails(offset) {
    return (dispatch) => {  
    listAllRawDumpApi.addOffset = `${GetMonthYear()}&BusinessUnit=${offset}&pagesize=100`
    api(listAllRawDumpApi).then(response => response.json())  // convert to json
    .then((data) => {
      dispatch({type:"Raw_Dump_WorkOrder_Details", payload:data })
    })
    .catch(err => console.log('Request Failed', err)) // Catch err      
    }
}
// ----------------------Raw File Uplaod Screen-----------------------------
export function UpdateRawDumpStatus(offset) {
	 return (dispatch) => {  
      dispatch({ type: 'Update_WO_Status_LOADING' }) 
	 	 UpdateRawDumpApi.addOffset = offset 
       api(UpdateRawDumpApi).then(response => response.json())  // convert to json
      .then(
             data => dispatch({ type: 'Update_WO_Status_SUCCESS', data }),
             error => dispatch({ type:'Update_WO_Status_ERROR', error: error.message || 'Unexpected Error!!!' })
        ) 
	 }
}



export function RawWorkOrderDetails(offset) {
    return (dispatch) => { 
     dispatch({ type: 'RAWWO_LOADING' }) 
    listAllRawDumpApi.addOffset = `${GetMonthYear()}&BusinessUnit=${offset}`
    api(listAllRawDumpApi).then(response => response.json())  // convert to json
    .then(
           data => dispatch({ type: 'RAWWO_SUCCESS', data }),
           error => dispatch({ type:'RAWWO_ERROR', error: error.message || 'Unexpected Error!!!' })
       ) 
    }
}

// ----------------------Approved Data-----------------------------
export function WOApprovedListDetails(offset) {
    return (dispatch) => { 
      listAllApprovedApi.addOffset = offset
       // listAllApprovedApi.addOffset = `BusinessUnit=${offset}`
     dispatch({ type: 'WOApproved_LOADING' }) 
    api(listAllApprovedApi).then(response => response.json())  // convert to json
    .then(
           data => dispatch({ type: 'WOApproved_SUCCESS', data }),
           error => dispatch({ type:'WOApproved_ERROR', error: error.message || 'Unexpected Error!!!' })
       ) 
    }
}


// ----------------------woGetPreviousMonth-----------------------------
export function WOGetPreviousMonthDetails() {
    return (dispatch) => { 
     dispatch({ type: 'WOGetPreviousMonth_LOADING' }) 
    api(woGetPreviousMonthsApi).then(response => response.json())  // convert to json
    .then(
           data => dispatch({ type: 'WOGetPreviousMonth_SUCCESS', data }),
           error => dispatch({ type:'WOGetPreviousMonth_ERROR', error: error.message || 'Unexpected Error!!!' })
       ) 
    }
}